/*
 * AICO SVZ prints engine — reads the [data-aico-svz] island and drives the SVZ name/number/badge
 * prints (derive sizes from print_rules, stock-gated number picker, /cart/add.js bundle on submit).
 */
(function () {
  'use strict';
  var CFG = window.aicoPerso || window.persoTool || {};

  // native fetch from a fresh iframe - the page's ajax-cart wrapper patches window.fetch and
  // re-serialises our multipart to JSON (image Blob -> "{}"); the iframe's fetch is untouched.
  // Fallback: XHR transport (immune to the fetch wrapper) when iframe fetch is unavailable
  // (Safari WKWebView in the club app blocks cross-origin iframe access).
  var _nativeFetch;
  function xhrFetch(url, opts) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(opts.method || 'GET', url);
      var h = opts.headers || {};
      Object.keys(h).forEach(function (k) { xhr.setRequestHeader(k, h[k]); });
      xhr.onload = function () { resolve({ ok: xhr.status >= 200 && xhr.status < 300, status: xhr.status, json: function () { return Promise.resolve(JSON.parse(xhr.responseText)); } }); };
      xhr.onerror = function () { reject(new Error('XHR failed')); };
      xhr.send(opts.body || null);
    });
  }
  function nativeFetch() {
    if (_nativeFetch) return _nativeFetch;
    try {
      var ifr = document.createElement('iframe');
      ifr.style.display = 'none'; ifr.setAttribute('aria-hidden', 'true');
      (document.body || document.documentElement).appendChild(ifr);
      var f = ifr.contentWindow && ifr.contentWindow.fetch;
      if (f) _nativeFetch = f.bind(ifr.contentWindow);
    } catch (e) {}
    return _nativeFetch || (_nativeFetch = xhrFetch);
  }

  // option-name detectors (read from the data, just classified by these patterns)
  var RX = {
    name:  /spieler/i,
    digit: /ziffer|nummer|number/i,
    size:  /gr.?sse|size/i,
    color: /farbe|colou?r/i
  };

  var DIVIDE_ICON = '<svg class="icon icon-divide-circle" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 12C7 11.4477 7.44772 11 8 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z" fill="currentColor"/></svg>';

  function arr(v) { return Array.isArray(v) ? v : (v == null || v === '' ? [] : [v]); }
  function listHas(list, val) { return arr(list).map(String).indexOf(String(val)) !== -1; }
  function el(tag, cls) { var n = document.createElement(tag); if (cls) n.className = cls; return n; }

  function formatMoney(cents) {
    var format = CFG.moneyFormat || '${{amount}}';
    cents = parseInt(cents, 10) || 0;
    var rx = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(num, p, t, d) {
      p = p == null ? 2 : p; t = t || "'"; d = d || '.';
      var n = (num / 100).toFixed(p), parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? d + parts[1] : '');
    }
    var m = format.match(rx), val;
    switch (m && m[1]) {
      case 'amount_no_decimals': val = fmt(cents, 0); break;
      case 'amount_with_comma_separator': val = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = fmt(cents, 0, '.', ','); break;
      default: val = fmt(cents, 2);
    }
    return format.replace(rx, val);
  }

  function Svz(root) {
    this.root = root;
    var island = root.querySelector('[data-aico-svz]');
    this.data = island ? JSON.parse(island.textContent) : { rules: [], prints: [] };
    this.form = root.querySelector('form') || document.querySelector('form[data-AddToCartForm], form[id^="product-form"]');
    this.controls = root.querySelector('[data-aico-svz-controls]');
    this.state = { mode: 'none', name: null, custom: '', number: null, badge: null }; // mode: none|predefined|custom
    this.inCart = {}; // variantId -> qty already in cart (so availability = inventory - inCart)
    this.init();
  }

  /* ---------- rule derivation ---------- */
  Svz.prototype.rule = function (kind, predicate) {
    return (this.data.rules || []).filter(function (r) { return r.kind === kind; }).find(predicate);
  };
  Svz.prototype.farbe = function () {
    var t = this.data.jersey.type;
    var r = this.rule('farbe', function (r) { return arr(r.matchType).length === 0 || listHas(r.matchType, t); });
    return r ? r.result : null;
  };
  Svz.prototype.nameSize = function () {
    var c = this.data.jersey.variant;
    var r = this.rule('name_size', function (r) { return arr(r.matchCut).length === 0 || listHas(r.matchCut, c); });
    return r ? r.result : null;
  };
  Svz.prototype.numberSize = function (chosenSize) {
    var jt = this.data.jersey.type, c = this.data.jersey.variant;
    var tokens = (chosenSize || '').split(/[\s(),\-\/]+/).filter(Boolean).map(function (t) { return t.toUpperCase(); });
    var r = this.rule('number_size', function (r) {
      var typeOk = arr(r.matchType).length === 0 || listHas(r.matchType, jt);
      var cutOk = arr(r.matchCut).length === 0 || listHas(r.matchCut, c);
      var sizeOk = arr(r.sizes).length === 0 || arr(r.sizes).some(function (s) { return tokens.indexOf(String(s).toUpperCase()) !== -1; });
      return typeOk && cutOk && sizeOk;
    });
    return r ? r.result : null;
  };

  /* ---------- print product classification ---------- */
  Svz.prototype.optIndex = function (print, rx) {
    var names = print.optionNames || [];
    for (var i = 0; i < names.length; i++) { if (rx.test(names[i])) return i; }
    return -1;
  };
  Svz.prototype.kindOf = function (print) {
    var t = (print.optionType || '').toLowerCase();
    if (t === 'player') return 'name';
    if (t === 'custom') return 'custom';
    if (t === 'number') return 'number';
    if (t === 'badge') return 'badge';
    // fallback (regex) for products without aico.option_type set
    if (this.optIndex(print, RX.digit) >= 0) return 'number';
    if (this.optIndex(print, RX.name) >= 0) return 'name';
    return 'custom';
  };

  // index of the option that holds the selectable value (aico.value_option), with regex fallback
  Svz.prototype.valueIdx = function (print) {
    var vo = print.valueOption, names = print.optionNames || [];
    if (vo) { for (var i = 0; i < names.length; i++) { if (String(names[i]).toLowerCase() === String(vo).toLowerCase()) return i; } }
    var k = this.kindOf(print);
    if (k === 'name') return this.optIndex(print, RX.name);
    if (k === 'number') return this.optIndex(print, RX.digit);
    if (k === 'badge') return this.optIndex(print, RX.color);
    return -1;
  };
  Svz.prototype.prints = function (kind) {
    var self = this;
    return (this.data.prints || []).filter(function (p) { return self.kindOf(p) === kind; });
  };

  // SVZ owns this jersey only if a linked print declares a valid aico.option_type;
  // otherwise leave it fully untouched (no controls, debug, or handlers).
  Svz.prototype.isConfigured = function () {
    var valid = { player: 1, custom: 1, number: 1, badge: 1 };
    return (this.data.prints || []).some(function (p) {
      return valid[String(p.optionType || '').toLowerCase()] === 1;
    });
  };

  /* find the variant whose option values contain ALL required values */
  function findVariant(print, required) {
    return (print.variants || []).find(function (v) {
      var opts = (v.options || []).map(String);
      return required.every(function (val) { return val != null && opts.indexOf(String(val)) !== -1; });
    });
  }

  /* ---------- chosen jersey size (only matters for Kinder number rule) ---------- */
  Svz.prototype.chosenSize = function () {
    // best-effort: read the selected option from the theme variant picker
    var sel = document.querySelector('.js-variants select, .js-variants input:checked');
    if (sel) return (sel.value || sel.getAttribute('value') || '').trim();
    return '';
  };

  /* ---------- init / render ---------- */
  Svz.prototype.init = function () {
    var self = this;
    // Not an SVZ product (linked prints have no valid aico.option_type) — leave the page alone.
    if (!this.isConfigured()) return;
    if (this.form) this.form.addEventListener('submit', function (e) { self.onSubmit(e); }, true);
    var qi = this.qtyInput();
    if (qi) { qi.addEventListener('input', function () { self.clampQty(); }); qi.addEventListener('change', function () { self.clampQty(); }); }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.adjust-plus, .adjust-minus')) setTimeout(function () { self.clampQty(); }, 0);
      if (e.target.closest && e.target.closest('[data-toggle]')) { e.preventDefault(); self.flip(); }
    });
    // load the cart first so availability = inventory - what's already in the cart
    // debug panel off by default; enable with window.aicoSvzDebug = true (or ?aicoSvzDebug in the URL)
    var DEBUG = (window.aicoSvzDebug === true) || /[?&]aicoSvzDebug\b/.test(window.location.search);
    this.loadCart(function () { if (DEBUG) self.renderDebug(); self.render(); });
    this.scaleNames();
    window.addEventListener('resize', function () { self.scaleNames(); });
  };

  Svz.prototype.scaleNames = function () {
    var inner = document.querySelector('.o-perso-tool__media-inner');
    if (!inner) return;
    var w = inner.offsetWidth;
    if (w <= 0) return;
    var r = 500;
    var factor = w < r ? Math.max(0.7, w / r) : Math.min(1.3, 1 + (w - r) / r * 0.3);
    Array.prototype.forEach.call(document.querySelectorAll('.o-perso-tool__media-block'), function (b) {
      var base = parseFloat(b.dataset.fontSize);
      if (!base || isNaN(base)) return;
      b.style.setProperty('--font-size', (base * factor / 10).toFixed(3) + 'rem');
    });
  };

  Svz.prototype.loadCart = function (cb) {
    var self = this;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var m = {};
        (c.items || []).forEach(function (i) { m[i.variant_id] = (m[i.variant_id] || 0) + (i.quantity || 0); });
        self.inCart = m;
      })
      .catch(function () { self.inCart = self.inCart || {}; })
      .finally(function () { if (cb) cb(); });
  };

  // (re)render the controls — clears + rebuilds so availability reflects the latest cart
  Svz.prototype.render = function () {
    if (!this.controls) { console.warn('[aico-svz] no controls container'); return; }
    this.controls.innerHTML = '';
    this.state = { mode: 'none', name: null, custom: '', number: null, badge: null };
    this.renderPrint();
    this.update();
  };

  // TEMP (config.honorContinueSelling): "continue selling" SKUs treated as unlimited until SVZ stock is authoritative
  Svz.prototype.continueSelling = function (variantId) {
    if (!(this.data.config && this.data.config.honorContinueSelling)) return false;
    var c = false;
    (this.data.prints || []).forEach(function (p) {
      (p.variants || []).forEach(function (v) { if (String(v.id) === String(variantId) && v.continueSelling) c = true; });
    });
    return c;
  };

  // remaining stock for a variant = inventory (at page load) - quantity already in the cart
  Svz.prototype.availableQty = function (variantId) {
    if (this.continueSelling(variantId)) return null; // sells past 0 -> treat as unlimited
    var inv = this.skuQty(variantId);
    if (inv == null) return null; // untracked -> unlimited
    return inv - (this.inCart[variantId] || 0);
  };

  Svz.prototype.showError = function (msg) {
    var w = document.querySelector('.m-product-form__error-message-wrapper');
    var m = document.querySelector('.m-product-form__error-message');
    if (w && m) { m.textContent = msg; w.removeAttribute('hidden'); } else console.warn('[aico-svz]', msg);
  };
  Svz.prototype.clearError = function () {
    var w = document.querySelector('.m-product-form__error-message-wrapper');
    if (w) w.setAttribute('hidden', '');
  };

  /* ---------- debug panel (temporary; remove before go-live) ---------- */
  Svz.prototype.renderDebug = function () {
    var d = this.data || {}, self = this, j = d.jersey || {};
    var farbe = this.farbe(), ns = this.nameSize(), nu = this.numberSize(this.chosenSize());
    var warns = [];
    if (!d.prints || !d.prints.length) warns.push('No print products loaded — are Spielername/Nummer PUBLISHED (Active + Online Store)? Draft products do not load via storefront Liquid.');
    if (!d.rules || !d.rules.length) warns.push('No print_rules loaded — is the print_rules metaobject created with entries?');
    if (!farbe) warns.push('No Farbe rule matches type "' + (j.type || '') + '" — add this exact value to a farbe rule\'s match_type.');
    if (!ns) warns.push('No name_size rule matches cut "' + (j.variant || '') + '".');
    if (!nu) warns.push('No number_size rule matches cut "' + (j.variant || '') + '" + size "' + this.chosenSize() + '".');

    var L = [];
    L.push('Jersey: type="' + (j.type || '') + '"  variant="' + (j.variant || '') + '"  size(picker)="' + this.chosenSize() + '"');
    L.push('Rules loaded: ' + ((d.rules || []).length));
    L.push('Prints found: ' + ((d.prints || []).length) + '   Players loaded: ' + ((d.players || []).length));
    (d.prints || []).forEach(function (p) {
      var vs = p.variants || [];
      var avail = vs.filter(function (v) { return v.available; }).length;
      var inStock = vs.filter(function (v) { return (v.inventoryQty || 0) > 0; }).length;
      L.push('  • ' + p.handle + '  kind=' + self.kindOf(p) +
             '  options=[' + (p.optionNames || []).join(', ') + ']' +
             '  variants=' + vs.length + '  available=' + avail + '  inStock(qty>0)=' + inStock);
    });
    L.push('Derived: Farbe=' + (farbe || 'NONE') + '  nameSize=' + (ns || 'NONE') + '  numberSize=' + (nu || 'NONE'));
    var npv = (d.prints || []).filter(function (p) { return self.kindOf(p) === 'name'; })[0];
    if (npv) {
      var bv = findVariant(npv, [farbe, ns]);
      L.push('Name base SKU [Farbe=' + farbe + ', size=' + ns + ']: ' + (bv ? ('price=' + bv.price + '  qty=' + bv.inventoryQty + '  options=[' + (bv.options || []).join(', ') + ']') : 'NOT FOUND — product option values do not match these'));
    }
    var nmv = (d.prints || []).filter(function (p) { return self.kindOf(p) === 'number'; })[0];
    if (nmv) {
      var bv2 = findVariant(nmv, [farbe, nu, '5']);
      L.push('Number SKU digit "5" [Farbe=' + farbe + ', size=' + nu + ']: ' + (bv2 ? ('price=' + bv2.price + '  qty=' + bv2.inventoryQty + '  options=[' + (bv2.options || []).join(', ') + ']') : 'NOT FOUND — check Farbe/size/digit values'));
    }
    if (npv) {
      var ni2 = self.optIndex(npv, RX.name);
      var firstName = (npv.variants && npv.variants[0] && npv.variants[0].options) ? npv.variants[0].options[ni2] : null;
      var num = self.playersMap()[firstName];
      L.push('Player→number: "' + firstName + '" → ' + (num != null && num !== '' ? '"' + num + '"' : 'NOT IN players metaobject — name does not match (no number → total stays name-only)'));
    }
    if ((d.prints || []).some(function (p) { return self.kindOf(p) === 'badge'; })) {
      L.push('Badge (derived): ' + (self.badgeFarbe() || 'NONE (no colour rule matched, or a hide rule matched)'));
      (d.rules || []).filter(function (r) { return r.kind === 'badge'; }).forEach(function (r) {
        var mt = (arr(r.matchType).length === 0 || listHas(r.matchType, j.type));
        var mc = (arr(r.matchCut).length === 0 || listHas(r.matchCut, j.variant));
        L.push('  badge rule: type=[' + arr(r.matchType).join(',') + '] cut=[' + arr(r.matchCut).join(',') + '] -> ' +
               (r.result ? '"' + r.result + '"' : '(hide)') + (mt && mc ? '   <== MATCHES' : ''));
      });
    }
    if (warns.length) { L.push(''); L.push('Warnings:'); warns.forEach(function (w) { L.push('  ! ' + w); }); }

    var box = document.createElement('details');
    box.open = true;
    box.style.cssText = 'background:#111;color:#7CFC00;font:12px/1.45 monospace;padding:10px 12px;margin:10px 0;border:1px solid #333;border-radius:6px;white-space:pre-wrap;word-break:break-word;';
    var sum = document.createElement('summary');
    sum.style.cssText = 'color:#ffd100;cursor:pointer;font-weight:700;';
    sum.textContent = 'AICO SVZ debug' + (warns.length ? ' — ' + warns.length + ' issue(s)' : ' — OK');
    box.appendChild(sum);
    box.appendChild(document.createTextNode('\n' + L.join('\n')));
    // place it UNDER the add-to-cart button
    var btn = document.querySelector('[data-btn-submit], .m-product-form__submit');
    var anchor = btn && (btn.closest('.m-product-form') || btn.closest('form'));
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor.nextSibling);
    else (this.controls || this.root).appendChild(box);
  };

  /* ---------- Print section (old-style: chips -> revealed dropdown / inputs) ---------- */
  Svz.prototype.hasBaseVariant = function (print) {
    return !!findVariant(print, [this.farbe(), this.nameSize()]);
  };

  Svz.prototype.renderPrint = function () {
    var self = this;
    var namePrints = this.prints('name').filter(function (p) { return self.hasBaseVariant(p); });
    var customPrints = this.prints('custom').filter(function (p) { return self.hasBaseVariant(p); });
    var numberPrints = this.prints('number');
    this._numberPrint = numberPrints[0] || null;
    this._customPrint = customPrints[0] || null;
    this._namePrints = namePrints;
    if (!namePrints.length && !customPrints.length) { this.renderBadge(); return; }

    var group = el('div', 'a-option');
    group.appendChild(el('div', 'a-option__label')).textContent = 'Print';
    var values = el('div', 'a-option__values');
    values.appendChild(this.chip('none', (CFG.strings && CFG.strings.none) || 'Ohne', true));
    var numBase = this.numberBasePrice();
    // one chip per name product (e.g. Spieler / Spielerinnen) — each opens its own player dropdown
    namePrints.forEach(function (np, i) {
      values.appendChild(self.chip('name:' + i, self.nameLabel(np), false, self.printBasePrice(np) + numBase));
    });
    if (customPrints.length) values.appendChild(this.chip('custom', customPrints[0].optionLabel || 'Individuell', false, this.printBasePrice(customPrints[0]) + numBase));
    group.appendChild(values);

    var fields = el('div', 'm-print'); fields.style.marginTop = '10px';

    // a player dropdown per name product (a player needs BOTH its name SKU and its number's digits in stock)
    this._predefWraps = [];
    namePrints.forEach(function (np, i) {
      var wrap = el('div'); wrap.style.display = 'none';
      wrap.appendChild(self.buildPlayerSelect(np, numberPrints[0]));
      self._predefWraps[i] = wrap;
      fields.appendChild(wrap);
    });

    // custom (Individuell): only when a Fantasienamen product exists. name input + number dropdown.
    if (customPrints.length) {
      this._customWrap = el('div', 'm-print'); this._customWrap.style.display = 'none';
      var cp = customPrints[0];
      var nameBox = el('div', 'm-print__fieldset');
      var nameI = el('input', 'm-print__field a-input__field a-input__field--full-width');
      nameI.type = 'text'; nameI.maxLength = (CFG.maxCharName || CFG.maxCharNameLength || 14); nameI.placeholder = 'Name';
      nameI.addEventListener('input', function () { self.onCustom(nameI.value, cp); self.update(); });
      this._customNameInput = nameI;
      nameBox.appendChild(nameI);
      var info = el('span', 'm-print__info body-fs-xs');
      info.textContent = (CFG.strings && CFG.strings.maxCharsName) || ('max. ' + (CFG.maxCharName || 14) + ' Zeichen');
      nameBox.appendChild(info);
      this._customWrap.appendChild(nameBox);
      if (numberPrints.length) {
        // leading "Ohne" entry so a picked number can be cleared again (name-only print)
        var nip = numberPrints[0], numItems = [{ value: '', label: (CFG.strings && CFG.strings.none) || 'Ohne' }];
        for (var n = 0; n <= 99; n++) numItems.push({ value: String(n), label: String(n), disabled: !self.isNumberAvailable(nip, n) });
        this._customWrap.appendChild(this.tomSelect(numItems, 'Nummer', function (val) { self.selectNumber(nip, val); self.update(); }));
      }
      fields.appendChild(this._customWrap);
    }

    group.appendChild(fields);
    this.controls.appendChild(group);

    this.renderBadge();
  };

  // chip label for a name product: aico.option_label if set, else a sensible default (men/women)
  Svz.prototype.nameLabel = function (np) {
    if (np.optionLabel) return np.optionLabel;
    return /spielerinn/i.test((np.handle || '') + ' ' + (np.title || '')) ? 'Spielerinnen' : 'Spieler';
  };

  // build the player dropdown for one name product
  Svz.prototype.buildPlayerSelect = function (np, numberPrint) {
    var self = this, ni = this.valueIdx(np), names = [], pmap = this.playersMap();
    (np.variants || []).forEach(function (v) { var nm = v.options[ni]; if (nm && names.indexOf(nm) === -1) names.push(nm); });
    var items = names
      .filter(function (nm) { var num = pmap[nm]; return num != null && num !== ''; }) // skip players missing from the players metaobject (no number → can't resolve stock)
      .map(function (nm) {
        var nameVar = findVariant(np, [self.farbe(), self.nameSize(), nm]);
        var num = pmap[nm], nameOk = false;
        if (nameVar) { var aqn = self.availableQty(nameVar.id); nameOk = (aqn == null) ? nameVar.available : (aqn >= 1); }
        var numOk = !!(numberPrint && self.isNumberAvailable(numberPrint, num));
        return { value: nm, label: num + ' - ' + nm, disabled: !(nameOk && numOk) };
      });
    return this.tomSelect(items, (CFG.strings && CFG.strings.selectPlayer) || 'Wähle den/die Spieler:in', function (val) {
      self.state.custom = '';
      if (val) self.selectPredefinedPlayer(np.handle, val, numberPrint); else { self.state.name = null; self.state.number = null; }
      self.update();
    });
  };

  // derive the badge colour for this jersey from print_rules (kind: badge); null = no badge.
  // A blank result means "hide the badge" and wins; otherwise the most specific rule wins
  // (type+cut beats type beats the catch-all), so admin ordering doesn't matter.
  Svz.prototype.badgeFarbe = function () {
    var t = this.data.jersey.type, c = this.data.jersey.variant;
    var matches = (this.data.rules || []).filter(function (r) {
      return r.kind === 'badge' &&
             (arr(r.matchType).length === 0 || listHas(r.matchType, t)) &&
             (arr(r.matchCut).length === 0 || listHas(r.matchCut, c));
    });
    if (!matches.length) return null;
    if (matches.some(function (r) { return !r.result; })) return null; // a blank rule hides the badge
    function specificity(r) { return (arr(r.matchType).length ? 1 : 0) + (arr(r.matchCut).length ? 1 : 0); }
    matches.sort(function (a, b) { return specificity(b) - specificity(a); });
    return matches[0].result;
  };

  // colour badge if it has >1 variant, else a single-variant badge added as-is (value_option ignored)
  Svz.prototype.badgeHasVariants = function (bp) { return (bp.variants || []).length > 1; };

  // resolve all badge products: variant badges pick by rule, single-variant added as-is, null = no badge
  Svz.prototype.resolveBadges = function () {
    var self = this, bps = this.prints('badge');
    if (!bps.length) return null;
    var derived = this.badgeFarbe();
    if (!derived) return null; // a blank/absent rule hides the badge for this jersey
    var items = [], ok = true, price = 0, plainImage = null, colourImage = null, variantLabel = null, companionLabel = null;
    bps.forEach(function (bp) {
      var variant;
      if (self.badgeHasVariants(bp)) {
        var vi = self.valueIdx(bp);
        variant = (bp.variants || []).find(function (v) { return String((v.options || [])[vi]) === String(derived); });
        if (!variantLabel) variantLabel = bp.optionLabel;
        if (variant && variant.image) colourImage = variant.image;
      } else {
        variant = (bp.variants || [])[0];
        if (!companionLabel) companionLabel = bp.optionLabel;
        if (variant && variant.image) plainImage = variant.image;
      }
      if (!variant) { ok = false; return; }
      var aq = self.availableQty(variant.id);
      if (!((aq == null) ? variant.available : (aq >= 1))) ok = false; // all-or-nothing stock
      price += (variant.price || 0);
      items.push({ variantId: variant.id, price: variant.price || 0 });
    });
    return {
      items: items, price: price, colour: derived,
      label: variantLabel || companionLabel || derived || 'Badge', // option_label (variant badge -> other badge) -> resolved variant name -> "Badge"
      available: ok && items.length > 0, plainImage: plainImage, colourImage: colourImage
    };
  };

  /* badge: ONE FE option (Ohne / the derived group); picking it adds every badge product to the bundle */
  Svz.prototype.renderBadge = function () {
    var rb = this.resolveBadges();
    if (!rb) return;
    var group = el('div', 'a-option');
    group.appendChild(el('div', 'a-option__label')).textContent = rb.label;
    var values = el('div', 'a-option__values');
    values.setAttribute('data-full-width', '');
    values.appendChild(this.badgeChip(null, rb)); // Ohne
    values.appendChild(this.badgeChip(rb, rb));   // the whole badge group
    group.appendChild(values);
    this.controls.appendChild(group);
  };

  Svz.prototype.badgeChip = function (sel, rb) {
    var self = this;
    if (!sel) {
      var c0 = el('div', 'a-option__value a-option__value--has-image a-option__value--full-width a-option--empty js-option');
      c0.setAttribute('data-option', 'badge'); c0.setAttribute('tabindex', '0');
      var t0 = el('span', 'a-option__text'); t0.innerHTML = DIVIDE_ICON + ' ' + ((CFG.strings && CFG.strings.none) || 'Ohne'); c0.appendChild(t0);
      c0.addEventListener('click', function () { self.selectBadge(null, c0); });
      return c0;
    }
    var disabled = !rb.available;
    var c = el('div', 'a-option__value a-option__value--has-image a-option__value--full-width js-option' + (disabled ? ' a-option__value--disabled' : ''));
    c.setAttribute('data-option', 'badge'); if (!disabled) c.setAttribute('tabindex', '0');
    var t = el('span', 'a-option__text');
    var img = rb.colourImage;
    if (img) t.innerHTML = '<img class="a-option__image" src="' + img + '" alt="">';
    t.appendChild(document.createTextNode(rb.label));
    c.appendChild(t);
    if (rb.price) { var p = el('span', 'a-option__price'); p.textContent = '+ ' + formatMoney(rb.price); c.appendChild(p); }
    if (!disabled) c.addEventListener('click', function () { self.selectBadge(rb, c); });
    return c;
  };

  Svz.prototype.selectBadge = function (rb, chip) {
    Array.prototype.forEach.call(this.controls.querySelectorAll('.a-option__value[data-option="badge"]'), function (n) { n.classList.remove('a-option__value--active'); });
    if (chip) chip.classList.add('a-option__value--active');
    // group: { items:[{variantId,price}], price, label(colour), image } or null; image = the multi-variant badge's matched variant
    this.state.badge = rb ? { items: rb.items, price: rb.price, label: rb.colour, plainImage: rb.plainImage, colourImage: rb.colourImage } : null;
    if (rb) { this.goToPersonalised(); } // jump to the canvas; keep the current side (badge shows on both)
    this.update();
  };

  // representative "this print costs X" price = a variant matching the derived Farbe + name size
  Svz.prototype.printBasePrice = function (print) {
    var v = findVariant(print, [this.farbe(), this.nameSize()]);
    return v ? v.price : 0;
  };

  // the Fantasienamen SKU for this jersey — carries the flat print fee in custom mode,
  // so it goes into the bundle even when only a number is chosen (name input empty)
  Svz.prototype.customVariant = function () {
    return this._customPrint ? findVariant(this._customPrint, [this.farbe(), this.nameSize()]) : null;
  };

  // representative single-digit number price (for the chip "from" estimate)
  Svz.prototype.numberBasePrice = function () {
    var np = this.prints('number')[0];
    if (!np) return 0;
    var v = findVariant(np, [this.farbe(), this.numberSize(this.chosenSize())]);
    return v ? v.price : 0;
  };

  Svz.prototype.chip = function (mode, label, empty, price) {
    var self = this;
    var c = el('div', 'a-option__value js-option' + (empty ? ' a-option__value--has-image a-option--empty' : ''));
    c.setAttribute('data-print-mode', mode); c.setAttribute('tabindex', '0');
    var t = el('span', 'a-option__text');
    if (empty) t.innerHTML = DIVIDE_ICON + ' ' + label; else t.textContent = label;
    c.appendChild(t);
    if (!empty) { var p = el('span', 'a-option__price'); p.textContent = '+ ' + formatMoney(price || 0); c.appendChild(p); }
    function pick() { self.setPrintMode(mode, c); }
    c.addEventListener('click', pick);
    c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
    return c;
  };

  Svz.prototype.setPrintMode = function (mode, chip) {
    Array.prototype.forEach.call(this.controls.querySelectorAll('.a-option__value[data-print-mode]'), function (n) { n.classList.remove('a-option__value--active'); });
    if (chip) chip.classList.add('a-option__value--active');
    this.state.mode = mode;
    this.state.name = null; this.state.number = null; this.state.custom = '';
    this.resetControls();
    var q = this.qtyInput(); if (q) q.value = 1;     // reset quantity on every mode switch
    var nameIdx = (mode.indexOf('name:') === 0) ? parseInt(mode.slice(5), 10) : -1;
    this._activeNamePrint = (nameIdx >= 0 && this._namePrints) ? this._namePrints[nameIdx] : null;
    (this._predefWraps || []).forEach(function (w, i) { if (w) w.style.display = (i === nameIdx) ? '' : 'none'; });
    if (this._customWrap) this._customWrap.style.display = (mode === 'custom') ? '' : 'none';
    if (nameIdx >= 0 || mode === 'custom') { this.showBack(); this.goToPersonalised(); }
    this.updateCustomNameEnabled();
    this.update();
  };

  /* flip the jersey to its back (the print goes on the back) */
  Svz.prototype.showBack = function () {
    Array.prototype.forEach.call(document.querySelectorAll('.o-perso-tool__media-item--front'), function (n) { n.classList.remove('active'); });
    Array.prototype.forEach.call(document.querySelectorAll('.o-perso-tool__media-item--back'), function (n) { n.classList.add('active'); });
  };
  /* flip to the front (the badge goes on the front) */
  Svz.prototype.showFront = function () {
    Array.prototype.forEach.call(document.querySelectorAll('.o-perso-tool__media-item--front'), function (n) { n.classList.add('active'); });
    Array.prototype.forEach.call(document.querySelectorAll('.o-perso-tool__media-item--back'), function (n) { n.classList.remove('active'); });
  };
  /* the rotate button: toggle front/back */
  Svz.prototype.flip = function () {
    Array.prototype.forEach.call(document.querySelectorAll('.o-perso-tool__media-item'), function (it) { it.classList.toggle('active'); });
  };

  /* navigate the Flickity product gallery to the personalised (last/canvas) cell */
  Svz.prototype.goToPersonalised = function () {
    var slider = document.querySelector('[data-ProductImageSlider], .product-image--slider, [id^="ProductImageSlider-"]');
    if (!slider) return;
    var cell = slider.querySelector('[data-perso-slide]');
    var index = cell ? parseInt(cell.getAttribute('data-index'), 10) : null;
    if (window.jQuery && typeof window.jQuery(slider).flickity === 'function') {
      try { window.jQuery(slider).flickity('select', index != null ? index : window.jQuery(slider).find('.product-image--cell').length - 1); return; } catch (e) {}
    }
    if (window.Flickity && window.Flickity.data) {
      var fl = window.Flickity.data(slider);
      if (fl) { if (index != null) fl.select(index); else fl.last(); return; }
    }
    if (cell && cell.scrollIntoView) { try { cell.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} }
  };

  // clear the player dropdown, custom name input and number dropdown back to their initial state
  Svz.prototype.resetControls = function () {
    (this._predefWraps || []).concat([this._customWrap]).forEach(function (w) {
      if (!w) return;
      Array.prototype.forEach.call(w.querySelectorAll('.ts-wrapper'), function (ts) { if (ts.__reset) ts.__reset(); });
    });
    if (this._customNameInput) this._customNameInput.value = '';
  };

  // enable the custom name input whenever the Fantasienamen SKU is in stock
  // (name and number are independently selectable — no cross-gating)
  Svz.prototype.updateCustomNameEnabled = function () {
    if (!this._customNameInput) return;
    var cv = this.customVariant();
    var aq = cv ? this.availableQty(cv.id) : null;
    var nameInStock = cv ? ((aq == null) ? cv.available : (aq >= 1)) : false;
    var off = !nameInStock;
    this._customNameInput.disabled = off;
    this._customNameInput.style.cursor = off ? 'not-allowed' : '';
  };

  // minimal TomSelect-style dropdown (same .ts-* markup the CSS expects); items: {value,label,disabled}
  Svz.prototype.tomSelect = function (items, placeholder, onChange) {
    var wrap = el('div', 'ts-wrapper single m-print__select a-select__field custom-select');
    var control = el('div', 'ts-control'); control.setAttribute('role', 'combobox'); control.setAttribute('tabindex', '0');
    var dd = el('div', 'ts-dropdown single'); dd.style.display = 'none';
    var search = null, optionEls = [];
    if (items.length > 10) {
      search = el('input', 'ts-search'); search.type = 'text';
      search.placeholder = (CFG.strings && CFG.strings.search) || 'Suchen…';
      search.addEventListener('click', function (e) { e.stopPropagation(); });
      search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase();
        optionEls.forEach(function (o) { o.style.display = o.textContent.toLowerCase().indexOf(q) !== -1 ? '' : 'none'; });
      });
      dd.appendChild(search);
    }
    var content = el('div', 'ts-dropdown-content'); dd.appendChild(content);
    function setLabel(t) { control.innerHTML = ''; control.appendChild(el('div', 'item')).textContent = t; }
    function open() {
      dd.style.display = 'block'; wrap.classList.add('dropdown-active', 'focus');
      if (search) { search.value = ''; optionEls.forEach(function (o) { o.style.display = ''; }); setTimeout(function () { search.focus(); }, 0); }
    }
    function close() { dd.style.display = 'none'; wrap.classList.remove('dropdown-active', 'focus'); }
    setLabel(placeholder);
    var ph = el('div', 'option'); ph.setAttribute('role', 'option'); ph.setAttribute('aria-disabled', 'true'); ph.textContent = placeholder; content.appendChild(ph);
    items.forEach(function (it) {
      var o = el('div', 'option'); o.setAttribute('role', 'option'); o.setAttribute('data-value', it.value); o.textContent = it.label; optionEls.push(o);
      if (it.disabled) { o.setAttribute('aria-disabled', 'true'); o.style.opacity = '.4'; o.style.textDecoration = 'line-through'; }
      else { o.setAttribute('data-selectable', ''); }
      o.addEventListener('click', function () {
        if (it.disabled) return;
        Array.prototype.forEach.call(content.children, function (c) { c.classList.remove('active', 'selected'); });
        o.classList.add('active', 'selected'); setLabel(it.label); wrap.classList.add('has-items'); close();
        onChange(it.value);
      });
      content.appendChild(o);
    });
    control.addEventListener('click', function () { dd.style.display === 'block' ? close() : open(); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    wrap.__reset = function () {
      setLabel(placeholder);
      Array.prototype.forEach.call(content.children, function (c) { c.classList.remove('active', 'selected'); });
      wrap.classList.remove('has-items', 'dropdown-active', 'focus');
      dd.style.display = 'none';
    };
    wrap.appendChild(control); wrap.appendChild(dd);
    return wrap;
  };

  Svz.prototype.selectName = function (handle, nm) {
    var print = (this.data.prints || []).find(function (p) { return p.handle === handle; });
    if (!print) { this.state.name = null; return; }
    var v = findVariant(print, [this.farbe(), this.nameSize(), nm]);
    this.state.name = v ? { handle: handle, variantId: v.id, label: nm, price: v.price, available: v.available } : { label: nm, missing: true };
  };

  Svz.prototype.onCustom = function (text, customPrint) {
    text = (text || '').trim();
    this.state.custom = text;
    if (!text) { this.state.name = null; return; }
    if (!customPrint) { this.state.name = { label: text, custom: true, propertyOnly: true }; return; } // no Fantasienamen product → property only
    var v = findVariant(customPrint, [this.farbe(), this.nameSize()]);
    this.state.name = v ? { handle: customPrint.handle, variantId: v.id, label: text, price: v.price, custom: true, available: v.available } : { label: text, missing: true };
  };

  // resolve which digit variant + inventory for a given digit, with current Farbe/size
  Svz.prototype.digitVariant = function (print, digit) {
    return findVariant(print, [this.farbe(), this.numberSize(this.chosenSize()), digit]);
  };

  Svz.prototype.isNumberAvailable = function (print, n) {
    var digits = String(n).split('');
    var counts = {};
    digits.forEach(function (d) { counts[d] = (counts[d] || 0) + 1; });
    var self = this;
    return Object.keys(counts).every(function (d) {
      var v = self.digitVariant(print, d);
      if (!v) return false;
      var aq = self.availableQty(v.id);
      return (aq == null) ? v.available : (aq >= counts[d]);
    });
  };

  // resolve a number into bundle lines (digit SKU(s) with qty), or null if unavailable
  Svz.prototype.numberLines = function (print, n) {
    if (!print || n === '' || n == null) return null;
    if (!this.isNumberAvailable(print, n)) return null;
    var digits = String(n).split(''), counts = {}, self = this, lines = [];
    digits.forEach(function (d) { counts[d] = (counts[d] || 0) + 1; });
    Object.keys(counts).forEach(function (d) {
      var v = self.digitVariant(print, d);
      if (v) lines.push({ variantId: v.id, qty: counts[d], price: v.price });
    });
    return { value: String(n), lines: lines };
  };

  Svz.prototype.selectNumber = function (print, n) {
    this.state.number = this.numberLines(print, n);
  };

  // name -> number map from the players metaobject
  Svz.prototype.playersMap = function () {
    if (this._pmap) return this._pmap;
    var m = {};
    (this.data.players || []).forEach(function (p) { if (p.name != null && p.name !== '') m[p.name] = p.number; });
    this._pmap = m; return m;
  };

  // predefined player -> name SKU + the player's number digit SKU(s)
  Svz.prototype.selectPredefinedPlayer = function (handle, nm, numberPrint) {
    this.selectName(handle, nm);
    var num = this.playersMap()[nm];
    this.state.number = (num != null && num !== '' && numberPrint) ? this.numberLines(numberPrint, num) : null;
  };

  /* ---------- quantity cap (a bundle needs 1 add-on unit per jersey) ---------- */
  Svz.prototype.skuQty = function (variantId) {
    var q = null;
    (this.data.prints || []).forEach(function (p) {
      (p.variants || []).forEach(function (v) { if (String(v.id) === String(variantId)) q = v.inventoryQty; });
    });
    return q; // null = untracked / not found → unlimited
  };

  // max bundles buyable = min over selected add-on SKUs of floor(inventory / per-bundle count)
  Svz.prototype.maxBundleQty = function () {
    var max = Infinity, s = this.state, self = this;
    if (s.name && s.name.variantId) { var nq = self.availableQty(s.name.variantId); if (nq != null) max = Math.min(max, nq); }
    else if (s.mode === 'custom') { // number-only still adds the fee SKU on submit — count its stock too
      var cv = this.customVariant();
      if (cv) { var cq = self.availableQty(cv.id); if (cq != null) max = Math.min(max, cq); }
    }
    if (s.number && s.number.lines) s.number.lines.forEach(function (l) {
      var q = self.availableQty(l.variantId); if (q != null) max = Math.min(max, Math.floor(q / l.qty));
    });
    if (s.badge && s.badge.items) s.badge.items.forEach(function (it) { var bq = self.availableQty(it.variantId); if (bq != null) max = Math.min(max, bq); });
    return max;
  };

  Svz.prototype.qtyInput = function () {
    return (this.form && this.form.querySelector('input[name="quantity"]')) || document.querySelector('input[name="quantity"]');
  };

  Svz.prototype.clampQty = function () {
    var q = this.qtyInput(); if (!q) return;
    var max = this.maxBundleQty();
    var plus = (this.form && this.form.querySelector('.adjust-plus')) || document.querySelector('.adjust-plus');
    function setPlus(disabled) {
      if (!plus) return;
      plus.disabled = disabled;
      plus.classList.toggle('is-disabled', disabled);
      plus.style.cursor = disabled ? 'not-allowed' : '';
      plus.style.opacity = disabled ? '0.4' : '';
    }
    if (max === Infinity) { q.removeAttribute('max'); setPlus(false); return; }
    q.setAttribute('max', max);
    if ((parseInt(q.value, 10) || 1) > max) q.value = Math.max(1, max);
    setPlus((parseInt(q.value, 10) || 1) >= max);
  };

  /* ---------- preview (reuse the existing media-block hooks) ---------- */
  Svz.prototype.update = function () {
    var block = document.querySelector('.o-perso-tool__media-block') || this.root;
    var nm = this.state.name ? this.state.name.label : (this.state.custom || '');
    Array.prototype.forEach.call(block.querySelectorAll('.o-perso-tool__name'), function (n) { n.textContent = nm || ''; });
    var num = this.state.number ? this.state.number.value : '';
    Array.prototype.forEach.call(block.querySelectorAll('.o-perso-tool__number'), function (n) {
      n.innerHTML = '';
      if (num === '') return;
      var base = (CFG.fileUrl || ''), suffix = n.getAttribute('data-image-suffix') || '', ext = n.getAttribute('data-image-extension') || 'png';
      // support both file naming conventions: unpadded (1-) and zero-padded to 2 digits (01-)
      var cands = [base + num + '-' + suffix + '.' + ext, base + ('0' + num).slice(-2) + '-' + suffix + '.' + ext];
      if (cands[1] === cands[0]) cands.length = 1;
      var img = document.createElement('img'); img.className = 'o-perso-tool__number-image'; img.alt = '';
      var i = 0; img.onerror = function () { if (++i < cands.length) img.src = cands[i]; else img.style.display = 'none'; };
      img.src = cands[0];
      n.appendChild(img);
    });
    var badge = this.state.badge;
    Array.prototype.forEach.call(block.querySelectorAll('.o-perso-tool__badge'), function (b) {
      b.classList.remove('o-perso-tool__badge--left', 'o-perso-tool__badge--right');
      if (badge && (badge.plainImage || badge.colourImage)) {
        var both = badge.plainImage && badge.colourImage;
        var html = '<span class="o-perso-tool__badge-combo' + (both ? ' o-perso-tool__badge-combo--two' : '') + '">';
        if (badge.plainImage)  html += '<img class="o-perso-tool__badge-image o-perso-tool__badge-mini--tl" src="' + badge.plainImage + '" alt="">';
        if (badge.colourImage) html += '<img class="o-perso-tool__badge-image o-perso-tool__badge-mini--br" src="' + badge.colourImage + '" alt="">';
        html += '</span>';
        b.innerHTML = html;
        b.classList.add(b.hasAttribute('data-front') ? 'o-perso-tool__badge--left' : 'o-perso-tool__badge--right');
      } else b.innerHTML = '';
    });
    this.updatePrice();
    this.clampQty();
    this.clearError();
    this.validate();
  };

  /* options total shown under the product price (matches the old "+ X CHF") */
Svz.prototype.updatePrice = function () {
  var s = this.state, total = 0;
  var isName = s.mode.indexOf('name:') === 0, isCustom = s.mode === 'custom';
  if (isName || isCustom) {
    var nameP = isName ? this._activeNamePrint : this.prints('custom')[0];
    // sobald ein/e konkrete/r Spieler:in gewählt ist: dessen ECHTEN Preis nehmen
    // (kann 0 sein bei Gratisflock) — vorher weiter den Platzhalter-Preis zeigen
    if (s.name && !s.name.missing && typeof s.name.price === 'number') {
      total += s.name.price;
    } else {
      total += nameP ? this.printBasePrice(nameP) : 0;
    }
    if (s.number && s.number.lines && s.number.lines.length) s.number.lines.forEach(function (l) { total += (l.price || 0) * l.qty; });
    else total += this.numberBasePrice();
  }
  if (s.badge && s.badge.price) total += s.badge.price;
  var txt = total > 0 ? '+ ' + formatMoney(total) : '';
  Array.prototype.forEach.call(document.querySelectorAll('[data-options-price]'), function (n) { n.textContent = txt; });
};

  Svz.prototype.validate = function () {
    var btn = document.querySelector('[data-btn-submit], .m-product-form__submit');
    var s = this.state, ok = true;
    if (s.mode.indexOf('name:') === 0) ok = !!(s.name && s.name.variantId);
    else if (s.mode === 'custom') {
      // name only, number only, or both — at least one (flat print fee either way)
      var hasName = !!(s.name && (s.name.variantId || s.name.propertyOnly));
      var hasNumber = !!(s.number && s.number.lines && s.number.lines.length);
      ok = hasName || hasNumber;
    }
    if (s.name && s.name.missing) ok = false;
    if (btn) btn.disabled = !ok;
    return ok;
  };

  /* Render the configured jersey (active media view: base image + name + number + badge) onto a
     canvas and return a small JPEG data URL — or null on any failure (never blocks add-to-cart).
     Positions/sizes are read from the live DOM so the output matches the on-screen preview. */
  Svz.prototype.captureImage = function (block, pfx) {
    return new Promise(function (resolve) {
      var done = false; function finish(v) { if (!done) { done = true; resolve(v); } }
      setTimeout(function () { finish(null); }, 8000); // hard cap so a stuck image never blocks the add
      try {
        if (!block) return finish(null);
        var active = block.querySelector('.' + pfx + '__media-item.active') || block.querySelector('.' + pfx + '__media-item') || block;
        // base jersey image: an <img> that isn't the number/badge; else a CSS background-image
        var baseEl = null, imgs = active.querySelectorAll('img');
        for (var i = 0; i < imgs.length; i++) { if (!imgs[i].closest('.' + pfx + '__number') && !imgs[i].closest('.' + pfx + '__badge')) { baseEl = imgs[i]; break; } }
        var measureEl = baseEl || active, baseRect = measureEl.getBoundingClientRect();
        if (!baseRect.width) return finish(null);
        var baseSrc = baseEl ? (baseEl.currentSrc || baseEl.src) : null;
        if (!baseSrc) { var bg = window.getComputedStyle(active).backgroundImage, m = bg && bg.match(/url\(["']?(.*?)["']?\)/); baseSrc = m ? m[1] : null; }
        if (!baseSrc) return finish(null);
        var nameEl = active.querySelector('.' + pfx + '__name');
        var numImg = active.querySelector('.' + pfx + '__number img');
        var badgeEls = Array.prototype.slice.call(active.querySelectorAll('.' + pfx + '__badge img'));
        function load(src) { return new Promise(function (res) { if (!src) return res(null); var im = new Image(); im.crossOrigin = 'anonymous'; im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = src; }); }
        var fontsReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
        Promise.all([load(baseSrc), load(numImg && (numImg.currentSrc || numImg.src)), fontsReady].concat(badgeEls.map(function (be) { return load(be.currentSrc || be.src); }))).then(function (r) {
          var base = r[0], num = r[1], badgeImgs = r.slice(3); // r[2] = fonts
          if (!base) return finish(null);
          var bw = base.naturalWidth || baseRect.width, bh = base.naturalHeight || baseRect.height;
          var scale = Math.min(1, 600 / bw), cw = Math.round(bw * scale), ch = Math.round(bh * scale);
          var canvas = document.createElement('canvas'); canvas.width = cw; canvas.height = ch;
          var ctx = canvas.getContext('2d');
          ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, cw, ch); // white bg (JPEG has no transparency → avoids black where the jersey PNG is transparent)
          ctx.drawImage(base, 0, 0, cw, ch);
          var sx = cw / baseRect.width, sy = ch / baseRect.height;
          function rectOf(el) { var rr = el.getBoundingClientRect(); return { x: (rr.left - baseRect.left) * sx, y: (rr.top - baseRect.top) * sy, w: rr.width * sx, h: rr.height * sy }; }
          if (num && numImg) { var rn = rectOf(numImg); ctx.drawImage(num, rn.x, rn.y, rn.w, rn.h); }
          badgeEls.forEach(function (be, bi) { var bImg = badgeImgs[bi]; if (bImg) { var rbb = rectOf(be); ctx.drawImage(bImg, rbb.x, rbb.y, rbb.w, rbb.h); } });
          if (badgeEls.length >= 2 && badgeEls[0].parentNode) { // short black diagonal divider between the two mini-badges
            var rc = rectOf(badgeEls[0].parentNode), cx = rc.x + rc.w / 2, cy = rc.y + rc.h / 2, h = Math.min(rc.w, rc.h) * 0.9 / 2 * Math.SQRT1_2;
            ctx.strokeStyle = '#000000'; ctx.lineWidth = Math.max(1, sy);
            ctx.beginPath(); ctx.moveTo(cx - h, cy + h); ctx.lineTo(cx + h, cy - h); ctx.stroke();
          }
          if (nameEl && nameEl.textContent && nameEl.textContent.trim()) {
            var cs = window.getComputedStyle(nameEl), rt = rectOf(nameEl);
            ctx.font = (cs.fontStyle || 'normal') + ' ' + (cs.fontWeight || 'normal') + ' ' + ((parseFloat(cs.fontSize) || 16) * sy) + 'px ' + (cs.fontFamily || 'sans-serif');
            ctx.fillStyle = cs.color || '#000'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
            ctx.fillText(nameEl.textContent.trim(), rt.x + rt.w / 2, rt.y + rt.h / 2);
          }
          try { canvas.toBlob(function (b) { finish(b); }, 'image/png'); } catch (e) { finish(null); }
        }).catch(function () { finish(null); });
      } catch (e) { finish(null); }
    });
  };

  /* ---------- add to cart ---------- */
  Svz.prototype.onSubmit = function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!this.validate()) return;
    var fd = new FormData(this.form);
    var jerseyId = fd.get('id');
    var qty = parseInt(fd.get('quantity'), 10) || 1;
    var maxQ = this.maxBundleQty();
    if (maxQ !== Infinity && qty > maxQ) qty = Math.max(1, maxQ); // never order more bundles than add-on stock allows
    var bundleId = Date.now();
    var parent = { _bundleId: bundleId, _bundleRole: 'parent', _bundleEngine: 'svz' };
    var children = [];

    if (this.state.name && (this.state.name.variantId || this.state.name.propertyOnly)) {
      parent._pName = this.state.name.label;
    }
    var nameChildId = (this.state.name && this.state.name.variantId) ? this.state.name.variantId : null;
    if (!nameChildId && this.state.mode === 'custom') {
      var cv = this.customVariant(); // number-only: the Fantasienamen SKU still rides along as the flat print fee
      if (cv) nameChildId = cv.id;
    }
    if (nameChildId) {
      children.push({ id: nameChildId, quantity: qty, properties: { _bundleId: bundleId, _bundleRole: 'child' } });
    }
    if (this.state.number && this.state.number.lines) {
      parent._pNumber = this.state.number.value;
      this.state.number.lines.forEach(function (ln) {
        children.push({ id: ln.variantId, quantity: ln.qty * qty, properties: { _bundleId: bundleId, _bundleRole: 'child' } });
      });
    }
    if (this.state.badge && this.state.badge.items && this.state.badge.items.length) {
      parent._pBadge = this.state.badge.label;
      this.state.badge.items.forEach(function (it) {
        children.push({ id: it.variantId, quantity: qty, properties: { _bundleId: bundleId, _bundleRole: 'child' } });
      });
    }

    var items = children.concat([{ id: jerseyId, quantity: qty, properties: parent }]);
    var self = this;
    this.clearError();

    // loading state like the theme: spinner + "loading" class (NOT a greyed disabled button)
    var btn = document.querySelector('[data-btn-submit], .m-product-form__submit');
    var loader = btn && btn.querySelector('.m-product-form__loader');
    if (btn) btn.classList.add('m-product-form__submit--loading');
    if (loader) loader.classList.remove('hide');

    function post(blob) {
    // multipart so the configured-jersey image rides as a native cart file-upload on the parent line
    // (Shopify hosts it and stores the CDN URL as the _trikotImage property — clickable in the order, not base64)
    var fd = new FormData();
    items.forEach(function (it, i) {
      fd.append('items[' + i + '][id]', it.id);
      fd.append('items[' + i + '][quantity]', it.quantity);
      var props = it.properties || {};
      Object.keys(props).forEach(function (k) { fd.append('items[' + i + '][properties][' + k + ']', props[k]); });
    });
    if (blob) fd.append('items[' + (items.length - 1) + '][properties][_trikotImage]', blob, 'trikot.png'); // parent jersey = last item
    var addRel = CFG.cartAddUrl || (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    var addUrl = /^https?:/.test(addRel) ? addRel : (window.location.origin + addRel); // absolute: iframe fetch has no usable relative base
    nativeFetch()(addUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, // no Content-Type: browser sets the multipart boundary
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { self.showError(res.description || res.message); self.loadCart(function () { self.render(); }); return; }
        // mirror the theme's no-drawer add: bump the header count + flash the center overlay
        var added = (res.items && res.items.length) ? res.items.reduce(function (a, t) { return a + (parseInt(t.quantity, 10) || 0); }, 0) : 1;
        var cc = document.getElementById('CartCount');
        if (cc) cc.innerText = (parseInt(cc.innerText, 10) || 0) + added;
        var ov = document.getElementById('js_pagewide_overlay');
        if (ov) {
          ov.style.visibility = 'visible'; ov.style.opacity = '1';
          setTimeout(function () { ov.style.opacity = '0'; }, 2000);
          setTimeout(function () { ov.style.visibility = 'hidden'; }, 2600);
        }
        if (window.WhatSub && window.WhatSub.dispatch) window.WhatSub.dispatch('PRODUCT_FORM_ADD_TO_CART', self.form);
        document.dispatchEvent(new CustomEvent('aico:perso:added', { detail: res, bubbles: true }));
        self.loadCart(function () { self.render(); }); // re-evaluate availability against the updated cart
      })
      .catch(function (err) { console.error('[aico-svz]', err); })
      .finally(function () {
        if (btn) btn.classList.remove('m-product-form__submit--loading');
        if (loader) loader.classList.add('hide');
      });
    }

    // attach the configured-jersey image only when something was personalised (name/number/badge);
    // a plain jersey with no add-on doesn't need it
    if (this.state.name || this.state.number || this.state.badge) {
      var imgBlock = document.querySelector('.o-perso-tool__media-block');
      this.captureImage(imgBlock, 'o-perso-tool').then(function (blob) {
        if (!blob && imgBlock) {
          // canvas capture failed (CORS / timeout / invisible element) — fall back to the
          // base jersey image URL so SVZ still receives an AusruestungAnweisung
          var active = imgBlock.querySelector('.o-perso-tool__media-item.active') || imgBlock.querySelector('.o-perso-tool__media-item') || imgBlock;
          var imgs = active.querySelectorAll('img');
          for (var i = 0; i < imgs.length; i++) {
            if (!imgs[i].closest('.o-perso-tool__number') && !imgs[i].closest('.o-perso-tool__badge')) {
              var src = imgs[i].currentSrc || imgs[i].src;
              if (src) { items[items.length - 1].properties._trikotImage = src; }
              break;
            }
          }
          items[items.length - 1].properties._trikotImageFallback = '1';
        }
        if (!blob && !imgBlock) {
          items[items.length - 1].properties._trikotImageFallback = '1';
        }
        post(blob);
      });
    } else {
      post(null);
    }
  };

  /* ---------- boot ---------- */
  var svzInstance = null;
  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-aico-svz-root]'), function (root) {
      if (root.__aicoSvz) return;
      try { root.__aicoSvz = svzInstance = new Svz(root); } catch (e) { console.error('[aico-svz] init failed', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.AicoSvz = Svz;
})();
